// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { ITrandSchema } from './TrandSchema';

export interface IGetMarketTrandResponseSchema {
  /** Средняя цена квартиры на рынке **/
  averagePrice?: string;
  /** Средняя цена квадратного метра на рынке **/
  averageSqmPrice?: string;
  /** Разница стоимости на начало и конец периода в процентах **/
  diffPercent?: string;
  /** Разница стоимости на начало и конец периода **/
  diffPrice?: string;
  /** Тренд изменения цены рост/падение/без изменения **/
  diffPriceTrand?: EDiffPriceTrand;
  /** Данные для вывода графика стоимости квартиры в текущем доме **/
  houseTrand?: ITrandSchema[];
  /** Данные для вывода графика стоимости квартиры на рынке **/
  marketTrand?: ITrandSchema[];
}
export enum EDiffPriceTrand {
  /** Цена уменьшилась **/
  'Decrease' = 'decrease',
  /** Цена увеличилась **/
  'Increase' = 'increase',
  /** Цена не изменилась **/
  'NoChange' = 'noChange',
}
